import { FormattedMessage } from 'react-intl';
import { PaloReviewReminder } from '@synergy/components-palo';
import { ReactElement } from 'react';
import { UserRole } from '@synergy/models';
import { useNavigate } from 'react-router';

import { ROUTES } from '../../sidebar-menu/navigation-drawer/routes';
import { useSelector } from '../../../store/use-appstate-selector';

export const ContactsLoginsReviewPopup = (): ReactElement | null => {
    const navigate = useNavigate();
    const account = useSelector(state => state.account);
    const user = useSelector(state => state.user);

    if (!account) {
        return null;
    }

    return (
        <PaloReviewReminder
            due={!!account.accountNeedsToBeChecked && true === user?.roles.includes(UserRole.ShopAdmin)}
            onGoToList={() => navigate(`${ROUTES.userContacts}?limit=50&page=1&sort=lastName&order=asc`)}
        >
            <FormattedMessage id="app.contacts.logins.reminderText" />
        </PaloReviewReminder>
    );
};
